import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./slices/UserSlice";
import membersReducer from "../store/slices/memberSlice";
import themeReducer from "../store/slices/themeSlice";
import payrollReducer from "../store/slices/payrollSlice";

// Combine all reducers
const appReducer = combineReducers({
  user: userReducer,
  members: membersReducer,
  theme: themeReducer,
  payroll: payrollReducer,
});

// Wrap the rootReducer to handle logout and preserve theme state
const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    const { theme } = state; // Preserve theme state
    state = { theme }; // Reset all other states
  }
  return appReducer(state, action);
};

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"], // Only persist the user slice
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store configuration
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      
    }),
});

// Persistor
export const persistor = persistStore(store);
